// extracted by mini-css-extract-plugin
module.exports = {"root":"button-root-8-B","content":"button-content-uRZ"};